import { render, staticRenderFns } from "./SearchResultListItemDetails.vue?vue&type=template&id=12997de9&scoped=true"
import script from "./SearchResultListItemDetails.vue?vue&type=script&lang=js"
export * from "./SearchResultListItemDetails.vue?vue&type=script&lang=js"
import style0 from "./SearchResultListItemDetails.vue?vue&type=style&index=0&id=12997de9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12997de9",
  null
  
)

export default component.exports